// extracted by mini-css-extract-plugin
export default {"MainBody":"NotFound_MainBody__rRgZi","imageContainer":"NotFound_imageContainer__C-VpN","buttonContainer":"NotFound_buttonContainer__mB4Nf"};